angular.module('dealerware.web.data').factory('DealerwareCustomerModel', function ($http, Model, $q, DataUtils, $dealerwareInternationalizationDateFormats) {
    var model = new Model({
        baseEndpoint: '/locations/:location_id/customers',
        requestTransforms: new function() {
            this.cleanData = function(args, data,isUpdate) {
                delete data.id;
                delete data.auth_token;
            };

            this.create = function(args, data) {
                this.cleanData(args, data);
            };

            this.saveInsurance = function(args, data) {
                var origData = $.extend(true, {}, data);

                $.each(data, function(k,v) { delete data[k]; });
                $.extend(data, {
                    id: origData.id,
                    insurance_preferences_attributes: origData.insurance_preferences});

                if (data.insurance_preferences_attributes && data.insurance_preferences_attributes[0].expires_on) {
                    data.insurance_preferences_attributes[0].expires_on = $dealerwareInternationalizationDateFormats.parseDateForRequest(
                                                                            data.insurance_preferences_attributes[0].expires_on,
                                                                            "YYYY-MM-DD");
                }
            };
        },
        responseTransforms: new function() {
            this.get = function(args, data) {
                // Phone number needs normalization to (nnn) nnn-nnnn.
                data.phone_number = DataUtils.getInstance().normalizePhoneNumber(data.phone_number);

                // Insurance expiration date needs to be formatted into MM/DD/YYYY.
                if (data.insurance_preferences && data.insurance_preferences.length && data.insurance_preferences[0].expires_on) {
                    data.insurance_preferences[0].expires_on = $dealerwareInternationalizationDateFormats.parseDateToDisplayOnTheApplication(
                                                                    data.insurance_preferences[0].expires_on,
                                                                    ['YYYY-MM-DD']);
                }
            };
        },
        customActions: {
            ccpaDelete: {
                method: 'DELETE',
                endpoint: '/locations/:location_id/customers',
                ignoreAssociations: true
            },
            create: {
                method: 'POST',
                ignoreAssociations: true
            },
            update: {
                method: 'PUT',
                endpoint: '/locations/:location_id/customers/:id',
                ignoreAssociations: true
            },
            get: {
                method: 'GET',
                endpoint: '/locations/:location_id/customers/:id',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            },
            blacklistCustomer: {
                method: 'POST',
                endpoint: '/locations/:location_id/customers/:id/blacklist',
                ignoreAssociations: true
            },
            unblacklistCustomer: {
                method: 'DELETE',
                endpoint: '/locations/:location_id/customers/:id/blacklist',
                ignoreAssociations: true
            },
            deleteInsuranceImage: {
                method: 'DELETE',
                endpoint: '/locations/:location_id/customers/:id/assets/insurances'
            },
            saveInsurance: {
                method: 'POST',
                endpoint: '/locations/:location_id/customers/:id/insurances',
                rootNode: 'customer',
                ignoreDefaultRootNodeResponse: true,
                ignoreAssociations: true
            }
        }
    });

    jQuery.extend(model.prototype,{
        getCustomerFullName: function() {
            return (this.hasOwnProperty('data') && angular.isObject(this.data) && this.data.hasOwnProperty('full_name')) ? this.data.full_name : undefined;
        },
        hasRole: function(role){
            var hasRole = false;
            if (role && isArray(role)) {
                var self = this;
                $.each(role,function(idx,val){
                    hasRole = self.inRole(val);
                    if (hasRole) { return false; }
                });
            } else {
                hasRole = this.inRole(role);
            }
            return hasRole;
        },
        inRole: function(role) {
            var inRole = false;
            var _self = this;
            if (this.data.roles_mapped && isArray(this.data.roles_mapped)) {
                $.each(this.data.roles_mapped,function(idx,val){
                    if ( val.name == 'superuser1' || val.name == role ) {
                        inRole = true;
                        return false;
                    }
                });
            }
            return inRole;
        },
        searchDisplay: function() {
            var s;
            if (this.data && isObject(this.data)) {
                var name = this.data.full_name;
                var phone = this.data.phone_number;
                s = phone ? name + ' ' + this.data.phone_number : name;
                if (!s) { s = this.data.email; }
            } else {
                s = this.data.email;
            }
            return s;
        },
        isComplete: function() {
            var complete = true;

            if (!this.data.hasOwnProperty('full_name') || !this.data.full_name) {
                complete = false;
            } else if (!this.data.hasOwnProperty('phone_number') || !this.data.phone_number) {
                complete = false;
            }

            return complete;
        },
        toSummaryString: function() {
            var s;
            if (this.data && isObject(this.data)) {
                var name = this.data.first_name + ' ' + this.data.last_name;
                var phone = this.data.phone_number;
                s = phone ? name + '<br>' + phone : name;
            }
            return s;
        },
        isRequired: function() {
            return !this.isComplete();
        },
        isUnchanged: function() {
            return this.data.first_name === this.master.first_name &&
                   this.data.last_name === this.master.last_name &&
                   this.data.phone_number === this.master.phone_number &&
                   this.data.email === this.master.email;
        }
    });

    return model;
});
